import { AdminType, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";

interface IGetAccommodationUnit {
  id?: number;
}

export interface IPostAccommodationUnit {
  title: string;
  building_id: number;
  unit_type_id: number;
  code?: string;
  floor: string;
  status?: "active" | "inactive" | "out_of_service";
}

export interface IPutAccommodationUnit {
  id: number;
  title: string;
  building_id: number;
  unit_type_id: number;
  code?: string;
  floor: string;
  status?: "active" | "inactive" | "out_of_service";
}

// GET Accommodation Units
export async function GetAccommodationUnits(params: IGetAccommodationUnit, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/accommodation/unit"), params, useGlobalLoader);
}

// POST Accommodation Units
export async function PostAccommodationUnit(params: IPostAccommodationUnit, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/accommodation/unit"), params, useGlobalLoader);
}
// PUT Accommodation Units
export async function PutAccommodationUnit(params: IPutAccommodationUnit, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/accommodation/unit"), params, useGlobalLoader);
}
